
import Popup from 'vux/src/components/popup/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'

import {DateBox, CheckInShow} from '@/components';
import {mapGetters} from 'vuex';

export default {
name: 'popup-condition',
components: {
Popup,
DateBox,
CheckInShow,
XButton,
},
props: {
value: {
type: Boolean,
default: false,
},
startDate: String,
endDate: String,
},
data(){
return {

};
},
computed: {
isShow: {
get(){
return this.value;
},
set(val){
this.$emit('input', val);
}
},
...mapGetters({
rooms: 'getRooms',
adults: 'getAdults',
children: 'getChildren',
}),
},
methods: {
onHideDetail(){
this.$emit('input', false);
},

onSearch(){
this.onHideDetail();
this.$emit('on-search');
},

onClick(){
this.$emit('on-click');
},
}
}



// WEBPACK FOOTER //
// ./src/views/hotel-list/components/PopupCondition.vue